import { render } from "./ConfVociPreferiteGenerali.vue?vue&type=template&id=14098c5a&scoped=true"
import script from "./ConfVociPreferiteGenerali.vue?vue&type=script&lang=js"
export * from "./ConfVociPreferiteGenerali.vue?vue&type=script&lang=js"

import "./ConfVociPreferiteGenerali.vue?vue&type=style&index=0&id=14098c5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14098c5a"]])

export default __exports__